<div
    class="p-4 flex items-center justify-center md:w-[420px] h-[420px] bg-[#FFFFFF] rounded-[16px] border border-[#E5E8EC]"
>
    <img
        *ngIf="selectedAsset && !imageLoadError"
        [src]="selectedAsset | assetPreview : 540"
        alt="Selected asset preview"
        tabindex="0"
        (click)="openImage(selectedAsset?.id)"
        (keyup.enter)="openImage(selectedAsset?.id)"
        (load)="onLoad()"
        (error)="onError()"
        class="w-full h-full object-contain cursor-zoom-in"
    />
    <div
        *ngIf="!selectedAsset || imageLoadError"
        class="w-full h-full flex items-center justify-center"
    >
        <img
            src="assets/icons/venduro-icon-light-grey.svg"
            alt="No image available"
            class="w-full h-full object-contain opacity-50"
        />
    </div>
</div>
<div class="flex flex-wrap gap-2 mt-4" *ngIf="displayAssets.length > 1 || (showSingleThumbnail && displayAssets.length === 1)">
    <div
        *ngFor="let asset of displayAssets"
        class="w-20 h-20 border-2 rounded-lg overflow-hidden cursor-pointer transition-colors duration-200"
        [class.border-primary-500]="selectedAsset?.id === asset.id"
        [class.border-gray-200]="selectedAsset?.id !== asset.id"
        [class.hover:border-gray-300]="selectedAsset?.id !== asset.id"
        tabindex="0"
        (click)="selectImage(asset.id)"
        (keyup.enter)="selectImage(asset.id)"
    >
        <img
            [src]="asset | assetPreview : 'thumb'"
            alt="Asset thumbnail"
            class="w-full h-full object-cover"
            vsfFallbackSrc
        />
    </div>
</div>
